import { useEffect, useContext } from "react";
import { CircularProgress } from "@material-ui/core";
import MainContext from "../context/main/mainContext";

export const PricingPreview = ({ isLoadingPreview, isElcUpgrade = false, previewLabel }) => {
  const mainContext = useContext(MainContext);
  const { stripe_subscription_preview_new_billing, resetPreviewState } = mainContext;

  useEffect(() => () => resetPreviewState(), []);

  if (!stripe_subscription_preview_new_billing) return null;

  return (
    <div class="column">
      <h3>Pricing Preview</h3>
      <p>Billed {previewLabel}</p>
      {(() => {
        if (isLoadingPreview) {
          return <CircularProgress />;
        }

        if (isElcUpgrade) {
          return (
            <dl className="grid grid-cols-2 gap-2">
              <dt>Leads</dt>
              <dd>${stripe_subscription_preview_new_billing.leadsTotal?.toFixed(2)}</dd>
              {stripe_subscription_preview_new_billing.discountPercent > 0 && (
                <>
                  <dt>Leads Discount</dt>
                  <dd>
                    {stripe_subscription_preview_new_billing.discountPercent}% ($
                    {(
                      stripe_subscription_preview_new_billing.leadsTotal
                      * (stripe_subscription_preview_new_billing.discountPercent / 100)
                    ).toFixed(2)}
                    )
                  </dd>
                  <dt>Discounted Amount</dt>
                  <dd>${stripe_subscription_preview_new_billing.leadsTotalDiscounted?.toFixed(2)}</dd>
                </>
              )}

              <dt>Billing Cycle progress</dt>
              <dd>
                {(
                  (1 - stripe_subscription_preview_new_billing.leadsProrationFactor)
                  * 100
                )?.toFixed(2)}
                %
              </dd>
              <dt>Existing Leads Total</dt>
              <dd>${stripe_subscription_preview_new_billing.existingLeadsTotal?.toFixed(2)}</dd>
              <dt>After Proration</dt>
              <dd>${stripe_subscription_preview_new_billing.proratedLeadsTotal?.toFixed(2)}</dd>

              <dt>Total</dt>
              <dd>${stripe_subscription_preview_new_billing.total?.toFixed(2)}</dd>
            </dl>
          );
        }

        return (
          <dl className="grid grid-cols-2 gap-2">
            <dt>Seats</dt>
            <dd>${stripe_subscription_preview_new_billing.seatsTotal?.toFixed(2)}</dd>

            <dt>Leads</dt>
            <dd>${stripe_subscription_preview_new_billing.leadsTotal?.toFixed(2)}</dd>

            <dt>CSV Enrichment</dt>
            <dd>${stripe_subscription_preview_new_billing.csvImportEnrichmentTotal?.toFixed(2)}</dd>

            <dt>Dedicated CSM</dt>
            <dd>${stripe_subscription_preview_new_billing.dedicatedCsmTotal?.toFixed(2)}</dd>

            <dt>Subtotal</dt>
            <dd>${stripe_subscription_preview_new_billing.subTotal?.toFixed(2)}</dd>

            {stripe_subscription_preview_new_billing.discountPercent > 0 && (
              <>
                <dt>Leads Discount</dt>
                <dd>
                  {stripe_subscription_preview_new_billing.discountPercent}% ($
                  {(
                    stripe_subscription_preview_new_billing.leadsTotal
                    * (stripe_subscription_preview_new_billing.discountPercent / 100)
                  ).toFixed(2)}
                  )
                </dd>
              </>
            )}

            <dt>Total</dt>
            <dd>${stripe_subscription_preview_new_billing.total?.toFixed(2)}</dd>
          </dl>
        );
      })()}
    </div>
  );
};
